/**
 * @generated SignedSource<<06fce88b6167078b4828f27d14c1baf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSystemConfigRelayQuery$variables = {
  id: string;
};
export type useSystemConfigRelayQuery$data = {
  readonly getSystem: {
    readonly config: any | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type useSystemConfigRelayQuery = {
  response: useSystemConfigRelayQuery$data;
  variables: useSystemConfigRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "System",
    "kind": "LinkedField",
    "name": "getSystem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "config",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSystemConfigRelayQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSystemConfigRelayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15280f342d8e92a5d7ab3745aede699c",
    "id": null,
    "metadata": {},
    "name": "useSystemConfigRelayQuery",
    "operationKind": "query",
    "text": "query useSystemConfigRelayQuery(\n  $id: ID!\n) {\n  getSystem(id: $id) {\n    id\n    config\n  }\n}\n"
  }
};
})();

(node as any).hash = "55065d0c1bb236560cfe4c62cef2d92c";

export default node;
